import { makeAutoObservable } from "mobx"
import { ObservableQueue } from "./notifications"

export type DialogOption = TableSelection | ValueSelection

export type TableSelection = {
	type: 'tableSelection'
	headers: {displayName: string, selector: string | ((v: unknown) => string | number | boolean)}[]
	values: Record<string, unknown>[]
}

export type ValueSelection = {
	type: 'valueSelection'
	values: string[] | number[]
}

type QueueEntry = {
	dialog: DialogOption
	onDequeue: (v?: unknown) => void
}

export class DialogService {

	/**
	 *
	 */
	constructor() {
		this._dialogQueue = new ObservableQueue<QueueEntry>()

		makeAutoObservable(this)
	}

	private _dialogQueue: ObservableQueue<QueueEntry>

	public get dialog(): QueueEntry | undefined {
		if (this._dialogQueue.head === null)
			return undefined
		
		return this._dialogQueue.head
	}

	public enqueueDialog(configuration: DialogOption, onDequeue: (v?: unknown) => void) {
		this._dialogQueue.enqueue({ dialog: configuration, onDequeue: onDequeue })
	}

	public selectOption(v?: unknown) {
		const dequeued = this._dialogQueue.dequeue()
		dequeued?.onDequeue(v)
	}

	public showSelectionBox(configuration: DialogOption): Promise<unknown> {
		const promise = new Promise((resolve, reject) => {
			this.enqueueDialog(configuration, (v?: unknown) => resolve(v))
		})

		return promise
	}

	}

export const dialogService = new DialogService()